angular.module('lsnBase.modelHelper', []);